(() => {
  if (window.VerynovReferenceCart) return;

  const formatMoney = (cents, currency) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const updateSlider = (slider) => {
    const list = slider.querySelector('[data-vn-upsell-list]');
    const previous = slider.querySelector('[data-vn-upsell-prev]');
    const next = slider.querySelector('[data-vn-upsell-next]');
    const position = slider.querySelector('[data-vn-upsell-position]');
    const progress = slider.querySelector('[data-vn-upsell-progress]');
    if (!list || !previous || !next) return;
    const cards = [...list.querySelectorAll('[data-vn-upsell-card]')];
    const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    const scrollable = maxScroll > 4;
    const progressValue = maxScroll ? Math.min(1, Math.max(0, list.scrollLeft / maxScroll)) : 0;
    const index = cards.length > 1 ? Math.round(progressValue * (cards.length - 1)) : 0;
    previous.disabled = !scrollable || list.scrollLeft <= 4;
    next.disabled = !scrollable || list.scrollLeft >= maxScroll - 4;
    const positionText = `${String(Math.min(index + 1, Math.max(cards.length, 1))).padStart(2, '0')} / ${String(Math.max(cards.length, 1)).padStart(2, '0')}`;
    const progressTransform = `scaleX(${cards.length ? (index + 1) / cards.length : 1})`;
    if (position && position.textContent !== positionText) position.textContent = positionText;
    if (progress && progress.style.transform !== progressTransform) progress.style.transform = progressTransform;
  };

  const initialise = (root = document) => {
    root.querySelectorAll('[data-vn-upsell-slider]').forEach((slider) => {
      const list = slider.querySelector('[data-vn-upsell-list]');
      if (!list || list.dataset.vnSliderReady === 'true') {
        updateSlider(slider);
        return;
      }
      list.dataset.vnSliderReady = 'true';
      list.addEventListener('scroll', () => updateSlider(slider), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => updateSlider(slider)).observe(list);
      updateSlider(slider);
    });
  };

  const addVariant = async (card, control, variantId) => {
    if (!card || !control || !variantId || card.dataset.vnAdding === 'true') return;
    const drawer = document.querySelector('cart-drawer');
    const message = card.querySelector('[data-vn-upsell-message]');
    const select = control.matches('[data-vn-upsell-variant]');
    const originalText = select ? '' : control.textContent;
    const chosen = select ? control.selectedOptions[0]?.textContent.trim() : '';
    card.dataset.vnAdding = 'true';
    card.classList.add('is-adding');
    control.disabled = true;
    control.setAttribute('aria-busy', 'true');
    if (!select) control.textContent = 'Adding…';
    if (message) message.textContent = chosen ? `Adding ${chosen}…` : 'Adding…';
    drawer?.setActiveElement?.(control);
    try {
      const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections, sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add this size.');
      if (drawer?.renderContents) drawer.renderContents(data);
      else window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      delete card.dataset.vnAdding;
      card.classList.remove('is-adding');
      control.disabled = false;
      control.removeAttribute('aria-busy');
      if (select) control.value = '';
      else control.textContent = originalText;
      if (message) message.textContent = error.message || 'Please try again.';
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-vn-upsell-variant][data-vn-auto-add]');
    if (!select?.value) return;
    const card = select.closest('[data-vn-upsell-card]');
    const option = select.selectedOptions[0];
    const regular = card?.querySelector('[data-vn-upsell-regular]');
    const compare = card?.querySelector('[data-vn-upsell-compare]');
    const price = Number(option?.dataset.price || 0);
    const compareAt = Number(option?.dataset.compareAtPrice || 0);
    if (regular) regular.textContent = formatMoney(price, card?.dataset.currencyCode);
    if (compare) { compare.hidden = compareAt <= price; compare.textContent = compareAt > price ? formatMoney(compareAt, card?.dataset.currencyCode) : ''; }
    addVariant(card, select, select.value);
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-vn-upsell-prev], [data-vn-upsell-next]');
    if (arrow) {
      const list = arrow.closest('[data-vn-upsell-slider]')?.querySelector('[data-vn-upsell-list]');
      if (list) list.scrollBy({ left: (arrow.hasAttribute('data-vn-upsell-prev') ? -1 : 1) * Math.max(220, list.clientWidth * .82), behavior: 'smooth' });
      return;
    }
    const button = event.target.closest('[data-vn-upsell-add]');
    if (button) addVariant(button.closest('[data-vn-upsell-card]'), button, button.dataset.variantId);
  });

  const observe = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.vnReferenceCartObserved === 'true') return;
    const drawerContent = drawer.querySelector('#CartDrawer');
    if (!drawerContent) return;
    drawer.dataset.vnReferenceCartObserved = 'true';
    let refreshQueued = false;
    const observer = new MutationObserver((mutations) => {
      const hasDrawerReplacement = mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length);
      if (!hasDrawerReplacement || refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        initialise(drawerContent);
      });
    });
    observer.observe(drawerContent, { childList: true });
    drawer.vnReferenceCartObserver = observer;
  };

  window.VerynovReferenceCart = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { initialise(); observe(); }, { once: true });
  else { initialise(); observe(); }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
